An array representing the employment history of the candidate.

This field is redacted and an empty list is returned when a candidate or job application is deleted.
